export default __webpack_public_path__ + "static/media/placeholder-image.e03a35db.png";